import { Link } from "react-router-dom";
import { Phone, MapPin, Mail } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";

export default function Footer() {
  const { settings } = useSettings();
  const { contact, serviceArea } = settings;
  return (
    <footer data-testid="footer" className="bg-black border-t border-rgv-darkred pt-14 pb-32 lg:pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <img
            src="/assets/logos/rgv-gaming-logo.png"
            alt="RGV Gaming"
            className="h-24 w-auto mb-4"
          />
          <p className="text-rgv-gray text-sm leading-relaxed max-w-sm">
            RGV Gaming brings the ultimate gaming experience straight to you — birthday parties,
            school events, corporate events, fundraisers, and more. We bring gaming to you.
          </p>
        </div>

        <div>
          <h4 className="font-display uppercase italic text-xl text-rgv-red mb-4">Quick Links</h4>
          <ul className="space-y-2 text-rgv-gray">
            <li><Link to="/" className="hover:text-white transition-colors">Home</Link></li>
            <li><Link to="/about" className="hover:text-white transition-colors">About Us</Link></li>
            <li><Link to="/packages" className="hover:text-white transition-colors">Party Packages</Link></li>
            <li><Link to="/events" className="hover:text-white transition-colors">Events</Link></li>
            <li><Link to="/summer-camps" className="hover:text-white transition-colors">Summer Camps</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display uppercase italic text-xl text-rgv-red mb-4">Get In Touch</h4>
          <ul className="space-y-3 text-rgv-gray">
            <li className="flex items-center gap-2">
              <MapPin className="h-4 w-4 text-rgv-red" /> {contact.city}
            </li>
            <li>
              <a href={`tel:${contact.phone}`} className="flex items-center gap-2 hover:text-white transition-colors">
                <Phone className="h-4 w-4 text-rgv-red" /> {contact.phone}
              </a>
            </li>
            <li>
              <a href={`mailto:${contact.email || "franco@rgvgaming.com"}`} className="flex items-center gap-2 hover:text-white transition-colors">
                <Mail className="h-4 w-4 text-rgv-red" /> Email Us
              </a>
            </li>
          </ul>
          {serviceArea?.length > 0 && (
            <p className="text-rgv-gray/70 text-sm mt-4" data-testid="footer-service-area">
              Serving {serviceArea.join(", ")} & the greater Rio Grande Valley.
            </p>
          )}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 mt-12 pt-6 border-t border-rgv-maroon flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-rgv-gray/60 text-sm">© 2026 RGV Gaming. All Rights Reserved.</p>
        <Link
          to="/admin"
          data-testid="staff-login-link"
          className="text-rgv-gray/30 hover:text-rgv-red text-xs transition-colors"
        >
          Staff Login
        </Link>
      </div>
    </footer>
  );
}
